import Modal from '@components/v2/ui/Modal/Modal';
import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import LangEnum from '../../lang/LangEnum';
import { getAuthLoginPath, getAuthStoreSignUpPath } from '../../routes/auth.routes';
import { useTranslation } from '../translation/TranslationContext';

const LOGO = {
  width: 150,
  height: 27,
};

const CLOSE_BUTTON_SPACE = 4.5;

type ConnectAccountModalProps = {
  open: boolean;
  onClose: () => void;
  brandSlug?: string;
};

const ConnectAccountModal = ({ open, onClose, brandSlug = '' }: ConnectAccountModalProps) => {
  const { translate } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();

  const handleRedirectToLogin = () => {
    history.push(getAuthLoginPath(brandSlug, search));
  };

  const handleRedirectToRegisterStore = () => {
    history.push(getAuthStoreSignUpPath(brandSlug, search));
  };

  return (
    <Modal
      isOpen={open}
      size="compact"
      onClose={onClose}
      header={{
        title: (
          <Box
            sx={(theme) => ({
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              paddingLeft: theme.spacing(CLOSE_BUTTON_SPACE),
            })}
          >
            <TeceoLogo width={LOGO.width} height={LOGO.height} />
          </Box>
        ),
      }}
      footer={{
        primaryAction: {
          label: LangEnum.LOGIN_LOGIN,
          onClick: handleRedirectToLogin,
        },
        secondaryAction: {
          label: LangEnum.LOGIN_REGISTER_MY_STORE,
          onClick: handleRedirectToRegisterStore,
        },
      }}
    >
      <Typography align="center" component="p">
        {translate(LangEnum.CONNECTIONS_SEARCH_BRANDS_LABEL)}
      </Typography>
    </Modal>
  );
};

export default ConnectAccountModal;
